<template>
  <div class="card-313 text-center">

    <div class="container">
      <img :src="image" :alt="alt" class="card-313-image">
      <div class="card-313-content top-right">
        <slot></slot>
      </div>
    </div>

  </div>
</template>

<script>
import mImg from "../Tags/Img";
import {CardProps} from "../Cards/CardProps";
import mA from "../Tags/A";

export default {
  name: "Card203.vue",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps,
  },
}
</script>

<style scoped>
.card-313 {
  width: 100%;
  transition: .2s ease-in-out all;
}

.card-313-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.top-right {
  position: absolute;
  top: 8px;
  right: 16px;
}
</style>